<template>
  <div class="flex flex-col c-spacing">

    <label 
      v-for="option in options" 
      :key="option.value"
      :class="{ 'bg-blue-1000 text-white s-checked': isChecked(option.value) }"
      class="rounded-full px-4 py-3 border-2 border-blue-1000 s-hover cursor-pointer s-checkbox-grid"
    >
      <div class="s-center-checkbox">
        <input 
          :class="{ 'checked': isChecked(option.value) }"
          type="checkbox" 
          :value="option.value"
          v-model="data"
        />
      </div>
      <div class="s-checkbox-center">
        <span class="ml-2 text-xl font-bold">
          {{ option.label }}
        </span>
      </div>

      <div /> <!-- spacer since we're using grid -->
    </label>

  </div>
</template>

<script>
export default {
  name: 'Checkboxes',
  computed: {
    data: {
      get () {
        return this.$store.state.exam_responses?.[this.question.prompt];
      },
      set(response) {
        this.$store.commit('SET_PROMPT_AND_QUESTION', { prompt: this.question.prompt, response });
      }
    }
  },
  props: {
    question: {
      required: true,
      type: Object
    },
    options: {
      required: true,
      type: Array,
    }
  },
  methods: {
    isChecked(value) {
      if (this.data) { // checkboxes data will always be an array, so check with includes
        return this.data.includes(value)
      } else return false;
    },
  },
}
</script>

<style lang="scss" scoped>

input[type=checkbox] {
  appearance: none;
}
.checked {
  color: #fff;
}
.checked::before {
  content: "✔";
}



.c-spacing {
  label {
    margin-bottom: 0.65em!important;
    min-width: 18rem;
    // border-color: #404A7B;
  }
  // input {
  //   display: none!important;
  // }
}

.s-checkbox-grid {
  display: grid;
  grid-template-columns: 1fr 10fr 1fr;
}
.s-center-checkbox {
  display: flex;
  align-items: center;
}
.s-checkbox-center {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  // border: 2px red solid;
}

</style>